module.exports = __webpack_public_path__ + "static/media/nip_outward.a0abe8e4.svg";